import isNumber from 'lodash/isNumber';

const parseScore = score => (isNumber(score) ? score.toFixed(2) : null);
const parseWeight = weight => (['low', 'average', 'high'].includes(weight) ? weight : null);

export const regionImpactToTableParser = data =>
  Object.keys(data).map(key => {
    const value = data[key];
    const {
      region,
      environmentScore,
      environmentWgt,
      socialScore,
      socialWgt,
      governanceScore,
      governanceWgt,
      totalScore,
      totalWgt,
    } = value;

    return [
      region,
      {
        name: region,
        impactNumber: parseScore(environmentScore),
        impactWeight: parseWeight(environmentWgt),
      },
      {
        name: region,
        impactNumber: parseScore(socialScore),
        impactWeight: parseWeight(socialWgt),
      },
      {
        name: region,
        impactNumber: parseScore(governanceScore),
        impactWeight: parseWeight(governanceWgt),
      },
      {
        name: region,
        impactNumber: parseScore(totalScore),
        impactWeight: parseWeight(totalWgt),
      },
    ];
  });
